const authSk = {
    "sign_in": "Prihlásiť sa",
    "email": "E-mailová adresa",
    "password": "Heslo",
    "sign_in_button": "Prihlásiť sa",
    "invalid_credentials": "Neplatné poverenia",
    "password_min_length": "Heslo musí mať dĺžku aspoň 8 znakov",
    "passwords_do_not_match": "Heslá sa nezhodujú",
    "invalid_token": "Neplatný token",
    "password_set": "Heslo nastavené",
    "confirm_password": "Potvrdiť heslo",
    "confirm_title": "Potvrdenie registrácie administrátora Quickpick",
    "confirm_text": "Na nastavenie účtu stačí zadať bezpečné heslo",
    "set_password": "Nastaviť heslo",
    "account_activated": "Účet aktivovaný",
    "account_activated_text": "Teraz sa môžete prihlásiť do svojho používateľského účtu pomocou poskytnutej e-mailovej adresy a hesla",
    "continue_to_login": "Pokračovať na prihlásenie",
    "forgotten_password": "Zabudnuté heslo",
    "unable_to_reset_password": "Interná chyba, heslo sa nepodarilo obnoviť.",
    "reset_password_title": "Obnoviť heslo",
    "reset_password_text": "Zadajte e-mailovú adresu, ktorú používate pre svoj účet. Na túto e-mailovú adresu vám pošleme odkaz na obnovenie hesla.",
    "send_reset_mail": "Odoslať odkaz na obnovenie hesla",
    "send_reset_mail_success": "Na uvedenú adresu bol odoslaný e-mail s ďalšími pokynmi",
    "invalid_email": "Neplatná e-mailová adresa",
    "reset_sent": "E-mail odoslaný",
    "change_password_title": "Zmeniť heslo",
    "change_password_success": "Heslo bolo úspešne zmenené",
    "roles": {
        "OWNER": "Administrátor",
        "MENU_EDITOR": "Úprava menu",
        "STAFF_MANAGER": "Riadenie zamestnancov"
    },
    "name": "Meno",
    "permissions": "Povolenia",
    "create_user_permissions": "Vytvoriť používateľské oprávnenia",
    "add_restaurant": "Pridať reštauráciu",
    "user_saved": "Používateľ uložený",
    "has_admin_permissions": "Oprávnenia správcu",
    "login_with_google": "Prihlásenie cez Google",
    "missing_perrmissions": "Nemáte potrebné oprávnenia na prístup k tejto stránke",
    "qp_signup_title": "Registrácia QuickPick",
    "qp_signup_text": "Vyplňte nižšie uvedené polia pre vytvorenie používateľského účtu!",
    "user_information": "Informácie o používateľovi",
    "restaurant_information": "Informácie o reštaurácii",
    "restaurant_shortname": "Identifikátor reštaurácie",
    "restaurant_name": "Názov reštaurácie",
    "create_profile": "Vytvoriť",
    "restaurant_name_short": "Názov reštaurácie musí mať aspoň 3 znaky",
    "identifier_example": "Príklad identifikátora",
    "invalid_shortname": "Identifikátor reštaurácie musí mať aspoň 3 znaky",
    "restaurant_shortname_already_in_use": "Identifikátor reštaurácie sa už používa",
    "name_missing": "Chýba meno",
    "signup_failed": "Registrácia zlyhala. Skúste to znova neskôr.",
    "no_restaurant_title": "Pre váš účet nebola vybratá žiadna reštaurácia",
    "no_restaurant_text": "Ak ste si práve vytvorili účet, mali by ste zaregistrovať aj svoju reštauráciu!",
    "no_restaurant_alt": "Ak ste mali získať prístup do reštaurácie, kontaktujte, prosím, správcu reštaurácie.",
    "no_user_created_yet": "Ešte nemáte účet?",
    "signup_success": "Registrácia úspešná",
    "grant_admin_title": "Udeliť oprávnenia správcu",
    "grant_admin_confirmation": "Používateľ s administrátorskými oprávneniami môže spravovať nastavenia reštaurácie, pridávať a odoberať používateľov, spravovať predplatné, platby a faktúry. Úprava menu nevyžaduje administrátorské oprávnenia.",
    "selected_user": "Vybraný používateľ",
    "delete_user_title": "Odstrániť používateľa",
    "delete_user_confirmation": "Vybraný používateľ bude z reštaurácie odstránený a už nebude mať prístup k jej jedálnemu lístku. Túto akciu nie je možné vrátiť späť.",
    "admin": "Administrátor",
    "activate_account": "Aktivovať účet",
    "account_pending_activation": "Váš používateľský účet čaká na aktiváciu.",
    "check_your_activate_email": "Skontrolujte si, prosím, svoju e-mailovú schránku a kliknite na aktivačný odkaz",
    "refresh_page": "Obnoviť stránku",
    "did_not_receive_activation_email": "Neprišiel mi aktivačný e-mail",
    "activate_tip": "Ak aktivačný e-mail nemôžete nájsť, skontrolujte aj priečinok s nevyžiadanou poštou. Ak tam nie je, kliknite na tlačidlo nižšie a odošlite ho znova.",
    "resend_email": "Znovu odoslať",
    "email_resent": "Aktivačný e-mail bol úspešne odoslaný znova. Skontrolujte si, prosím, svoju e-mailovú schránku.",
    "accept_terms_and_conditions": "Prečítal(a) som si a súhlasím so <a>Zmluvnými podmienkami a Zásadami ochrany osobných údajov</a>",
    "complete_registration": "Dokončite registráciu",
    "auth_in_progress": "Prebieha overovanie...",
    "account_successfully_activated": "Váš účet QuickPick bol úspešne aktivovaný",
    "continue_to_home_page": "Pokračovať na domovskú stránku",
    "invalid_activation": "Pri aktivácii účtu sa vyskytla chyba. Skúste to znova neskôr alebo kontaktujte našu zákaznícku podporu.",
    "activation_mail_sent": "Začali sme vytvárať váš účet. Skontrolujte si, prosím, svoju e-mailovú schránku a dokončite registráciu kliknutím na odkaz v e-maile."
};

export default authSk;
